export default "__VITE_ASSET__CRkIB_aK__"